export const INITIAL_ERROR_STATE = { type: "", status: "" };
export const DEFAULT_ERROR_TEXT = "default_type/default_status";
